import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import { SportsEsportsOutlined as MineIcon } from "@mui/icons-material";
import { colors, borderRadiusPx } from "../../../../../theme";
import { LOTTERY_NAMES } from "../../../../../static/Constants";
import { NoData, CommonButton } from "../../../../Components/ui";

const MineLotteryEmptyState = ({ onReset, hasActiveFilters = false }) => {
  return (
    <Box
      sx={{
        bgcolor: colors.dashboard.cardBg,
        borderRadius: borderRadiusPx.xl,
        border: `1px solid ${colors.dashboard.cardBorder}`,
        p: { xs: 4, md: 6 },
        textAlign: "center",
        my: 3,
      }}
    >
      <NoData
        icon={<MineIcon sx={{ fontSize: 36, color: colors.purple[600] }} />}
        title={hasActiveFilters ? "No Matching Minefields Found" : "No Active Minefields !"}
        subtitle={
          hasActiveFilters
            ? `Try adjusting your search terms or clearing your filters to discover open ${LOTTERY_NAMES.MINEBET} games.`
            : "There are currently no active Mine lotteries open. Please check back shortly or explore other lottery games!"
        }
        paper={false}
      />
      {hasActiveFilters && onReset && (
        <Box sx={{ mt: 2 }}>
          <CommonButton
            variant="purpleAction"
            size="small"
            onClick={onReset}
            label="Reset Search Filters"
          />
        </Box>
      )}
    </Box>
  );
};

MineLotteryEmptyState.propTypes = {
  onReset: PropTypes.func,
  hasActiveFilters: PropTypes.bool,
};

export default MineLotteryEmptyState;
